import { api } from 'app/utils/api/helpers'

export const postApplicationRequestAccess = (applicationGuid, payload) => {
  return api.post(`sm/applications/${applicationGuid}/request-access`, payload)
}
